<template>
  <div class="dialog-root">
    <div class="container">
      <div class="desc">
        <div v-for="item in scoreDictData" :key="item.dictKey">
          {{ item.dictKey + '、' + item.dictValue }}
        </div>
      </div>
      <div class="score">
        <div>
          <div class="item">
            <span>普通话</span>
            <el-rate v-model="formData.languageScore" show-text :texts="scoreTexts"> </el-rate>
          </div>
          <div class="item">
            <span>服务态度</span>
            <el-rate v-model="formData.serviceScore" show-text :texts="scoreTexts"> </el-rate>
          </div>
          <div class="item">
            <span>业务能力</span>
            <el-rate v-model="formData.busiScore" show-text :texts="scoreTexts"> </el-rate>
          </div>
        </div>
      </div>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder" v-if="!rowData.scoreFlag"></div>
    <!-- 底部操作按钮 -->
    <div class="btn" v-if="!rowData.scoreFlag">
      <el-button type="primary" size="small" @click="doSave"> 保存 </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { scoreApi } from '@/api/call-system/call-manage/recording-manage';

export default {
  props: ['projectId', 'rowData'],
  data() {
    return {
      formData: {}, // 表单数据
      scoreDictData: [], // 评分字典
      scoreTexts: [], // 评分文本描述
    };
  },

  created() {
    let { id, languageScore, serviceScore, busiScore } = this.rowData;
    this.formData = {
      id,
      languageScore,
      serviceScore,
      busiScore,
    };
    Promise.resolve([
      { dictKey: 1, dictValue: '非常不满意' },
      { dictKey: 2, dictValue: '不满意' },
      { dictKey: 3, dictValue: '一般' },
      { dictKey: 4, dictValue: '满意' },
      { dictKey: 5, dictValue: '非常满意' },
    ]).then((data) => {
      this.scoreDictData = data;
      this.scoreTexts = data.map((item) => item.dictValue);
    });
  },
  methods: {
    /* 保存 */
    doSave() {
      if (
        !(
          this.formData.languageScore > 0 &&
          this.formData.serviceScore > 0 &&
          this.formData.busiScore > 0
        )
      ) {
        this.$message.warning('请先完成所有评分项!');
        return;
      }
      scoreApi(this.formData, {
        showLoading: { text: '处理中...' },
      }).then(() => {
        this.$message.success('操作成功!');
        this.$emit('update');
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

.desc {
  display: flex;
  align-content: center;
  justify-content: space-around;
  margin-bottom: 20px;
}

.score {
  display: flex;
  flex-direction: column;
  align-items: center;

  .item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    width: 300px;

    span {
      width: 100px;
    }
  }
}
</style>
